import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import CollapseDispatch from '../../../contexts/collapseDispatch';
import collapseActions from '../../../actions/collapse.actions';

import style from './ClientPanelShowAll.module.css';

const ClientPanelShowAll = React.memo(({ title, forCard }) => {
  const dispatch = useContext(CollapseDispatch);

  const handleClick = () => {
    switch (forCard) {
      case 'contacts':
        dispatch({
          type: collapseActions.CONTACTS_SHOW_ALL_SUCCESS,
        });
        break;
      case 'addresses':
        dispatch({
          type: collapseActions.ADDRESSES_SHOW_ALL_SUCCESS,
        });
        break;
      default:
        break;
    }
  };

  return (
    <div
      role="button"
      tabIndex="0"
      onKeyDown={() => {}}
      className={style.main}
      onClick={handleClick}
    >
      <div className={style.line}>{title}</div>
    </div>
  );
});

ClientPanelShowAll.propTypes = {
  title: PropTypes.string.isRequired,
  forCard: PropTypes.string.isRequired,
};

export default ClientPanelShowAll;
